import { PLATFORMS } from '@/pages/app/dashboard/creators/platforms';

export default function getPlatformFromUrl(url: string) {
	return PLATFORMS.find(
		(platform) =>
			url?.startsWith(`https://www.${platform.id}.com`) ||
			url?.startsWith(`https://${platform.id}.com`),
	);
}
